module.exports = __webpack_public_path__ + "img/21f.e6de9ae4.png";